const Logo = () => {
  return (
    <div className="flex justify-center w-56">
      <span className="font-bold text-3xl text-green-400">👾 나장봇</span>
    </div>
  );
};
export default Logo;
